// extracted by mini-css-extract-plugin
export default {"image":"XX-z","loaded":"YX-z","placeholder":"ZX-z"};